import * as React from "react";
import { ShoppingCart } from "lucide-react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
export default function CartContent() {
  return <section data-section-id="201478" id="cart-content" className="dark bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 max-w-5xl">
        <div className="mb-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold font-default text-foreground tracking-widest uppercase mb-4">
            Ritual Selection
          </h1>
          <p className="text-muted-foreground font-default max-w-2xl mx-auto text-lg tracking-wide">
            Review your chosen journey and sacred nourishment before finalizing your presence.
          </p>
        </div>

        <Card className="border-border/20 shadow-2xl shadow-primary/10 bg-card/40 backdrop-blur-xl overflow-hidden rounded-none">
          <CardHeader className="border-b border-border/10 bg-muted/10 pb-6">
            <CardTitle className="text-xl font-default flex items-center gap-3 tracking-wider uppercase">
              <div className="p-2 bg-primary/5 rounded-none border border-primary/20">
                <ShoppingCart className="w-5 h-5 text-primary" />
              </div>
              Sacred Summary
            </CardTitle>
          </CardHeader>
          <CardContent className="p-6 font-default">
            {}
            <WooCommerceCartBlock />
          </CardContent>
        </Card>
      </div>
    </section>;
}